export default {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
    english: 'English',
    french: 'French',

    locales: {
        en: {
            name: 'English',
            realName: 'English',
        },
        fr: {
            name: 'French',
            realName: 'Français',
        },
        nl: {
            name: 'Dutch',
            realName: 'Nederlands',
        },
    },
};
